import {
  getProjectFotoDisplayUrl,
  projectFotoIsImage,
  resolveProjectFotoPreviewUrl,
  type ProjectFoto,
} from "@/lib/projectOverview";
import { Lightbox, type LightboxSlide } from "@/pages/material/Lightbox";
import { PROJECT_OVERVIEW_NESTED_OVERLAY_Z } from "@/projectOverview/projectOverviewLayers";

export interface ProjectFotoLightboxState {
  images: LightboxSlide[];
  index: number;
}

function isProjectFotoImage(foto: ProjectFoto): boolean {
  return projectFotoIsImage(foto);
}

export function projectFotoLightboxState(
  orderId: number,
  fotos: ProjectFoto[],
  current: ProjectFoto,
): ProjectFotoLightboxState {
  const images = (fotos.length ? fotos : [current]).filter(isProjectFotoImage);
  const list = images.length ? images : [current];
  const index = Math.max(
    0,
    list.findIndex((foto) => foto.id === current.id),
  );
  return {
    index,
    images: list.map((foto) => ({
      url: getProjectFotoDisplayUrl(orderId, foto.id),
      fallbackUrl: resolveProjectFotoPreviewUrl(orderId, foto),
      filename: foto.filename || foto.original_filename || "foto.jpg",
      contentType: foto.content_type,
    })),
  };
}

export function ProjectFotoLightbox({
  state,
  onClose,
  onIndexChange,
}: {
  state: ProjectFotoLightboxState | null;
  onClose: () => void;
  onIndexChange: (index: number) => void;
}) {
  const current = state?.images[state.index] ?? state?.images[0] ?? null;
  return (
    <Lightbox
      url={current?.url ?? null}
      slides={state?.images}
      slideIndex={state?.index ?? 0}
      onSlideIndexChange={onIndexChange}
      copySource={
        current
          ? {
              url: current.url,
              filename: current.filename || "foto.jpg",
              contentType: current.contentType || "image/jpeg",
            }
          : null
      }
      onClose={onClose}
      zIndexClass={PROJECT_OVERVIEW_NESTED_OVERLAY_Z}
    />
  );
}
